var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload"},[_c('el-button',{staticClass:"upload__btn",on:{"click":_vm.onDefaultSelect}},[_vm._v("Use ESU2 Logo")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }